import React, { useState, useEffect, useRef } from 'react'
import { supabase } from '../lib/supabase'
import { useAuth } from '../hooks/useAuth'
import toast from 'react-hot-toast'

const TCMS_STYLES = `
  .tribe-mention { background:#F3E8FF; color:#6B2FA0; font-weight:700; padding:1px 7px; border-radius:8px; }
  .tribe-mention-menu { position:absolute; top:100%; left:0; margin-top:4px; width:250px; max-height:220px; overflow-y:auto; background:#fff; border:1px solid #E8E6DF; border-radius:10px; box-shadow:0 6px 18px rgba(13,27,62,.12); z-index:50; }
  .tribe-mention-item { display:flex; align-items:center; gap:8px; padding:8px 12px; font-size:13px; color:#2C2C2C; cursor:pointer; }
  .tribe-mention-item:hover { background:#F8F0FF; color:#6B2FA0; font-weight:600; }
  .tribe-mention-ini { width:24px; height:24px; border-radius:50%; background:#0D1B3E; color:#C9A84C; font-size:10px; font-weight:700; display:inline-flex; align-items:center; justify-content:center; flex-shrink:0; }
  .tcms-hero { background:linear-gradient(135deg,#0D1B3E,#1A3A5E 60%,#3A2A6E); color:#fff; border-radius:16px; padding:24px 28px; margin-bottom:20px; position:relative; overflow:hidden; }
  .tcms-hero::before { content:''; position:absolute; top:-50%; right:-10%; width:400px; height:400px; background:radial-gradient(circle,rgba(168,124,232,0.18),transparent 70%); pointer-events:none; }
  .tcms-hero-title { font-family:'Cormorant Garamond',serif; font-size:26px; font-weight:600; color:#C9A84C; margin:0 0 6px; position:relative; }
  .tcms-hero-sub { font-size:13px; color:rgba(255,255,255,0.7); line-height:1.6; position:relative; }

  .tcms-tabs { display:flex; gap:0; border-bottom:2px solid #E8E6DF; margin-bottom:20px; flex-wrap:wrap; }
  .tcms-tab { padding:10px 18px; font-size:13px; font-weight:600; cursor:pointer; border:none; background:none; color:#7A7870; border-bottom:3px solid transparent; margin-bottom:-2px; transition:all 0.15s; font-family:inherit; white-space:nowrap; display:flex; align-items:center; gap:6px; }
  .tcms-tab:hover { color:#0D1B3E; }
  .tcms-tab.active { color:#0D1B3E; border-bottom-color:#A87CE8; }
  .tcms-tab-badge { background:#E24B4A; color:#fff; font-size:10px; font-weight:700; padding:1px 7px; border-radius:10px; }

  .tcms-card { background:#fff; border:1px solid #E8E6DF; border-radius:14px; overflow:hidden; margin-bottom:14px; }
  .tcms-card-header { padding:14px 18px; background:#F8F7F4; border-bottom:1px solid #E8E6DF; display:flex; align-items:center; justify-content:space-between; gap:8px; flex-wrap:wrap; }
  .tcms-card-title { font-size:13px; font-weight:600; color:#0D1B3E; }
  .tcms-card-body { padding:18px; }

  .tcms-form { display:flex; flex-direction:column; gap:12px; }
  .tcms-label { font-size:11px; font-weight:600; color:#7A7870; letter-spacing:0.06em; margin-bottom:4px; display:block; }
  .tcms-input, .tcms-textarea, .tcms-select { width:100%; padding:10px 12px; border:1.5px solid #E0D9CC; border-radius:8px; font-size:13px; font-family:inherit; box-sizing:border-box; background:#fff; }
  .tcms-input:focus, .tcms-textarea:focus, .tcms-select:focus { outline:none; border-color:#A87CE8; }
  .tcms-textarea { resize:vertical; min-height:80px; line-height:1.6; }

  .tcms-btn-primary { padding:10px 20px; border-radius:8px; border:none; background:linear-gradient(135deg,#A87CE8,#7C4FCE); color:#fff; cursor:pointer; font-size:13px; font-weight:600; font-family:inherit; }
  .tcms-btn-primary:hover:not(:disabled) { background:linear-gradient(135deg,#7C4FCE,#A87CE8); }
  .tcms-btn-primary:disabled { opacity:0.5; cursor:not-allowed; }
  .tcms-btn-ghost { padding:8px 16px; border-radius:8px; background:none; border:1px solid #E0D9CC; color:#7A7870; cursor:pointer; font-size:12px; font-family:inherit; }
  .tcms-btn-icon { background:none; border:none; cursor:pointer; padding:4px 8px; border-radius:6px; font-size:14px; }
  .tcms-btn-icon:hover { background:#F0EEE8; }

  .tcms-row { padding:14px 18px; border-bottom:1px solid #F0EEE8; display:flex; gap:12px; align-items:flex-start; }
  .tcms-row:last-child { border-bottom:none; }
  .tcms-row:hover { background:#FAFAF8; }

  .tcms-badge { font-size:10px; font-weight:700; padding:2px 8px; border-radius:10px; letter-spacing:0.04em; }
  .tcms-badge.ceo { background:#A87CE8; color:#fff; }
  .tcms-badge.pinned { background:#C9A84C; color:#0D1B3E; }
  .tcms-badge.member { background:#E8E6DF; color:#4A4840; }
  .tcms-badge.new { background:#E24B4A; color:#fff; }
  .tcms-badge.researching { background:#FDF6E3; color:#8A5C00; }
  .tcms-badge.building { background:#EAF5EE; color:#2D7A4F; }
  .tcms-badge.shipped { background:#A87CE8; color:#fff; }
  .tcms-badge.archived { background:#F0EEE8; color:#B8B5AB; }

  .tcms-pp-card { border:1px solid #E8E6DF; border-radius:12px; padding:16px; margin-bottom:12px; background:#fff; }
  .tcms-pp-head { display:flex; justify-content:space-between; align-items:flex-start; gap:12px; flex-wrap:wrap; margin-bottom:10px; }
  .tcms-pp-meta { font-size:11px; color:#7A7870; }
  .tcms-pp-text { font-size:13px; color:#1A1A1A; line-height:1.7; white-space:pre-line; padding:10px; background:#FAFAF8; border-radius:8px; margin-top:8px; }
  .tcms-pp-fix { font-size:12px; color:#4A4840; line-height:1.6; padding:8px 12px; background:#F0F4FF; border-left:3px solid #4B5EAA; border-radius:6px; margin-top:8px; white-space:pre-line; }

  .tcms-empty { text-align:center; padding:50px 20px; color:#B8B5AB; }
  .tcms-empty-icon { font-size:48px; margin-bottom:12px; opacity:0.6; }

  .tcms-stat-grid { display:grid; grid-template-columns:repeat(auto-fit,minmax(160px,1fr)); gap:12px; margin-bottom:20px; }
  .tcms-stat-card { background:#fff; border:1px solid #E8E6DF; border-radius:12px; padding:14px 16px; }
  .tcms-stat-label { font-size:10px; font-weight:600; color:#7A7870; letter-spacing:0.08em; margin-bottom:6px; }
  .tcms-stat-value { font-family:'Cormorant Garamond',serif; font-size:28px; font-weight:600; color:#0D1B3E; line-height:1; }
  .tcms-stat-sub { font-size:11px; color:#B8B5AB; margin-top:4px; }

  .tcms-check { display:flex; align-items:center; gap:8px; cursor:pointer; font-size:13px; color:#4A4840; }
`

const PAIN_CATEGORIES = {
  general:          'General',
  tech:             '🛠️ Tech / Platform',
  client:           '🤝 Client / Borrower',
  regulation:       '⚖️ Regulation',
  feature_request:  '💡 Feature Request',
  other:            '❓ Other',
}

const PP_STATUSES = ['new', 'researching', 'building', 'shipped', 'archived']
const CS_STATUSES = ['planned', 'researching', 'building', 'shipped']

function timeAgo(date) {
  const seconds = Math.floor((new Date() - new Date(date)) / 1000)
  if (seconds < 60) return 'just now'
  const minutes = Math.floor(seconds / 60)
  if (minutes < 60) return `${minutes}m ago`
  const hours = Math.floor(minutes / 60)
  if (hours < 24) return `${hours}h ago`
  const days = Math.floor(hours / 24)
  if (days < 7) return `${days}d ago`
  const d = new Date(date)
  return d.toLocaleDateString('en-US', { month:'short', day:'numeric', year:'numeric' })
    + ' · ' + d.toLocaleTimeString('en-US', { hour:'2-digit', minute:'2-digit' })
}

// ── 💜 @MENTIONS ─────────────────────────────────────────────────
function tcmsInitials(name) {
  if (!name) return '?'
  const parts = String(name).trim().split(/\s+/)
  return ((parts[0]?.[0] || '') + (parts[1]?.[0] || '')).toUpperCase() || '?'
}

function escRegex(s) { return s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') }

function MentionText({ text, names }) {
  const content = String(text || '')
  if (!content.includes('@')) return <>{content}</>
  const sorted = (names || []).slice().sort((a, b) => b.length - a.length)
  const pattern = ['everyone', ...sorted.map(escRegex)].join('|')
  let re
  try { re = new RegExp(`@(${pattern})`, 'gi') } catch (e) { return <>{content}</> }
  const parts = []
  let last = 0, m
  while ((m = re.exec(content)) !== null) {
    if (m.index > last) parts.push(content.slice(last, m.index))
    parts.push(<span key={`m${m.index}`} className="tribe-mention">@{m[1]}</span>)
    last = m.index + m[0].length
  }
  if (last < content.length) parts.push(content.slice(last))
  return <>{parts}</>
}

function MentionInput({ as = 'textarea', value, onChange, members, extraOptions = [], onKeyDown, className, placeholder, style }) {
  const ref = useRef(null)
  const [query, setQuery] = useState(null)

  function updateQuery(el) {
    try {
      const caret = el.selectionStart
      const upto = (el.value || '').slice(0, caret)
      const at = upto.lastIndexOf('@')
      if (at === -1) { setQuery(null); return }
      if (at > 0 && !/[\s(]/.test(upto[at - 1])) { setQuery(null); return }
      const q = upto.slice(at + 1)
      if (q.length > 30 || q.includes('\n')) { setQuery(null); return }
      setQuery({ start: at, text: q })
    } catch (e) { setQuery(null) }
  }

  const matches = query === null ? [] : [
    ...extraOptions.filter(o => o.full_name.toLowerCase().startsWith(query.text.toLowerCase())),
    ...(members || []).filter(mm => (mm.full_name || '').toLowerCase().startsWith(query.text.toLowerCase())),
  ].slice(0, 6)

  function pick(name) {
    const el = ref.current
    const caret = el ? el.selectionStart : String(value).length
    const next = String(value).slice(0, query.start) + '@' + name + ' ' + String(value).slice(caret)
    onChange(next)
    setQuery(null)
    setTimeout(() => {
      try { el.focus(); const pos = query.start + name.length + 2; el.setSelectionRange(pos, pos) } catch (e) { /* ignore */ }
    }, 0)
  }

  const Tag = as
  return (
    <div style={{ position: 'relative', flex: as === 'input' ? 1 : undefined }}>
      <Tag ref={ref} className={className} placeholder={placeholder} value={value} style={style}
        onChange={e => { onChange(e.target.value); updateQuery(e.target) }}
        onKeyUp={e => updateQuery(e.target)}
        onClick={e => updateQuery(e.target)}
        onBlur={() => setTimeout(() => setQuery(null), 150)}
        onKeyDown={onKeyDown}
      />
      {query !== null && matches.length > 0 && (
        <div className="tribe-mention-menu">
          {matches.map(mm => (
            <div key={mm.id || mm.full_name} className="tribe-mention-item"
              onMouseDown={e => { e.preventDefault(); pick(mm.full_name) }}>
              {mm.icon
                ? <span style={{ fontSize: 14 }}>{mm.icon}</span>
                : <span className="tribe-mention-ini">{tcmsInitials(mm.full_name)}</span>}
              <span>{mm.full_name}</span>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}

function extractMentionIds(text, members, selfId) {
  const found = new Set()
  const content = String(text || '').toLowerCase()
  ;(members || []).forEach(mm => {
    if (mm.id && mm.id !== selfId && mm.full_name && content.includes('@' + mm.full_name.toLowerCase())) found.add(mm.id)
  })
  return [...found]
}

async function saveMentions({ postId = null, commentId = null, text, members, authorId }) {
  try {
    const ids = extractMentionIds(text, members, authorId)
    if (ids.length === 0) return
    await supabase.from('tribe_mentions').insert(ids.map(uid => ({
      post_id: postId, comment_id: commentId, mentioned_user_id: uid, author_id: authorId,
    })))
  } catch (e) { console.warn('[TribeCMS] mention save error:', e.message) }
}

// ─── MANAGE POSTS TAB ─────────────────────────────────────────────
function ManagePostsTab({ userId }) {
  const [posts,     setPosts]     = useState([])
  const [loading,   setLoading]   = useState(true)
  const [composing, setComposing] = useState('')
  const [pinning,   setPinning]   = useState(true)
  const [posting,   setPosting]   = useState(false)
  const [openThread,  setOpenThread]  = useState({}) // postId -> bool
  const [comments,    setComments]    = useState({}) // postId -> [comments]
  const [replyDrafts, setReplyDrafts] = useState({}) // postId -> string
  const [replying,    setReplying]    = useState(null) // postId sending
  const [likeCounts,  setLikeCounts]  = useState({}) // postId -> like count
  const [commentCounts, setCommentCounts] = useState({}) // postId -> reply count
  const [members, setMembers] = useState([])              // for @mentions

  // 💜 Light member list for the @ picker
  useEffect(() => {
    async function loadMembers() {
      try {
        const { data } = await supabase
          .from('profiles')
          .select('id, full_name')
          .eq('role', 'notary')
          .eq('is_approved', true)
          .order('full_name', { ascending: true })
        setMembers(data || [])
      } catch (e) { console.warn('[TribeCMS] members load error:', e.message) }
    }
    loadMembers()
  }, [])
  const mentionNames = members.map(mm => mm.full_name).filter(Boolean)

  // 🔔 NEW-since-last-visit: capture "last seen" at mount, BEFORE the portal layout
  // stamps it to "now". Anything created after this moment gets a gold NEW pill.
  const [prevSeen] = useState(() => {
    try {
      // Prefer the prev-seen snapshot (stable for the whole visit — survives tab
      // switches). Fall back to last_seen, which still holds the PRE-visit value
      // at first render because the portal layout stamps it only AFTER mount.
      return localStorage.getItem('lca_lounge_prev_seen')
          || localStorage.getItem('lca_lounge_last_seen')
    } catch (e) { return null }
  })
  const [newReplyPosts, setNewReplyPosts] = useState({}) // postId -> has new replies
  const firstNewRef  = useRef(null)
  const scrolledRef  = useRef(false)
  const isNewSince = ts => !!(prevSeen && ts && new Date(ts) > new Date(prevSeen))

  useEffect(() => { load() }, []) // eslint-disable-line

  // 🔔 Once posts render, glide to the first NEW item (one time per visit).
  useEffect(() => {
    if (loading || scrolledRef.current || !firstNewRef.current) return
    scrolledRef.current = true
    setTimeout(() => {
      try { firstNewRef.current && firstNewRef.current.scrollIntoView({ behavior: 'smooth', block: 'center' }) } catch (e) { /* ignore */ }
    }, 300)
  }, [loading, posts, newReplyPosts])

  async function load() {
    try {
      const { data } = await supabase
        .from('tribe_posts')
        .select('*, author:profiles!tribe_posts_author_id_fkey(full_name)')
        .order('is_pinned', { ascending: false })
        .order('created_at', { ascending: false })
        .limit(100)
      setPosts(data || [])

      const ids = (data || []).map(p => p.id)
      if (ids.length) {
        const { data: likeRows } = await supabase.from('tribe_post_likes').select('post_id').in('post_id', ids)
        const counts = {}
        ;(likeRows || []).forEach(l => { counts[l.post_id] = (counts[l.post_id] || 0) + 1 })
        setLikeCounts(counts)

        const { data: commentRows } = await supabase.from('tribe_post_comments').select('post_id').in('post_id', ids)
        const cCounts = {}
        ;(commentRows || []).forEach(c => { cCounts[c.post_id] = (cCounts[c.post_id] || 0) + 1 })
        setCommentCounts(cCounts)

        // 🔔 Which posts got new replies since the last visit? Auto-open those threads.
        if (prevSeen) {
          const { data: freshRows } = await supabase
            .from('tribe_post_comments')
            .select('post_id, author_id')
            .in('post_id', ids)
            .gt('created_at', prevSeen)
          const freshMap = {}
          ;(freshRows || []).forEach(c => { if (c.author_id !== userId) freshMap[c.post_id] = true })
          setNewReplyPosts(freshMap)
          const openIds = Object.keys(freshMap)
          if (openIds.length) {
            setOpenThread(prev => { const next = { ...prev }; openIds.forEach(id => { next[id] = true }); return next })
            openIds.forEach(id => loadComments(id))
          }
        }
      }
    } catch (err) {
      console.warn('[TribeCMS] posts load error:', err.message)
    } finally {
      setLoading(false)
    }
  }

  async function publishCEO() {
    if (!composing.trim() || !userId) return
    setPosting(true)
    try {
      const { data: newPost, error } = await supabase.from('tribe_posts').insert({
        author_id:   userId,
        content:     composing.trim(),
        is_ceo_post: true,
        is_pinned:   pinning,
      }).select('id').single()
      if (error) throw error
      await saveMentions({ postId: newPost?.id || null, text: composing, members, authorId: userId })
      toast.success('🎉 CEO post published to the tribe!!')
      setComposing('')
      load()
    } catch (err) {
      toast.error(err.message)
    } finally {
      setPosting(false)
    }
  }

  async function togglePin(p) {
    await supabase.from('tribe_posts').update({ is_pinned: !p.is_pinned }).eq('id', p.id)
    toast.success(p.is_pinned ? 'Unpinned' : '📌 Pinned to top of feed')
    load()
  }

  async function deletePost(p) {
    if (!window.confirm(`Delete this post?\n\n"${p.content.slice(0,80)}${p.content.length>80?'...':''}"`)) return
    await supabase.from('tribe_posts').delete().eq('id', p.id)
    toast.success('Post deleted')
    load()
  }

  async function loadComments(postId) {
    try {
      const { data } = await supabase
        .from('tribe_post_comments')
        .select('*, author:profiles!tribe_post_comments_author_id_fkey(full_name)')
        .eq('post_id', postId)
        .order('created_at', { ascending: true })
      setComments(prev => ({ ...prev, [postId]: data || [] }))
      setCommentCounts(prev => ({ ...prev, [postId]: (data || []).length }))
    } catch (err) {
      console.warn('[TribeCMS] comments load error:', err.message)
    }
  }

  function toggleThread(postId) {
    setOpenThread(prev => {
      const next = { ...prev, [postId]: !prev[postId] }
      if (next[postId] && !comments[postId]) loadComments(postId)
      return next
    })
  }

  async function sendReply(postId) {
    const text = (replyDrafts[postId] || '').trim()
    if (!text || !userId) return
    setReplying(postId)
    try {
      const { data: newComment, error } = await supabase.from('tribe_post_comments').insert({
        post_id:        postId,
        author_id:      userId,
        content:        text,
        is_ceo_comment: true,
      }).select('id').single()
      if (error) throw error
      await saveMentions({ postId, commentId: newComment?.id || null, text, members, authorId: userId })
      setReplyDrafts(prev => ({ ...prev, [postId]: '' }))
      toast.success('💜 Replied to the tribe as CEO!!')
      loadComments(postId)
    } catch (err) {
      toast.error(err.message)
    } finally {
      setReplying(null)
    }
  }

  async function deleteComment(postId, commentId) {
    if (!window.confirm('Delete this reply?')) return
    try {
      await supabase.from('tribe_post_comments').delete().eq('id', commentId)
      toast.success('Reply deleted')
      loadComments(postId)
    } catch (err) {
      toast.error(err.message)
    }
  }

  if (loading) return <div className="tcms-empty">Loading posts...</div>

  return (
    <>
      <div className="tcms-card">
        <div className="tcms-card-header">
          <span className="tcms-card-title">💜 Post as CEO</span>
        </div>
        <div className="tcms-card-body">
          <div className="tcms-form">
            <MentionInput
              as="textarea"
              className="tcms-textarea"
              placeholder="Speak to your tribe... share a win, drop wisdom, celebrate someone!! (Type @ to mention — or @everyone!)"
              value={composing}
              onChange={setComposing}
              members={members}
              extraOptions={[{ full_name: 'everyone', icon: '📣' }]}
              style={{ minHeight: 110, width: '100%' }}
            />
            <label className="tcms-check">
              <input type="checkbox" checked={pinning} onChange={e => setPinning(e.target.checked)} style={{ width:'auto' }} />
              <span>📌 Pin to top of feed (recommended for important announcements)</span>
            </label>
            <div style={{ display:'flex', justifyContent:'flex-end' }}>
              <button className="tcms-btn-primary" onClick={publishCEO} disabled={!composing.trim() || posting}>
                {posting ? 'Publishing...' : '🚀 Publish to Tribe'}
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="tcms-card">
        <div className="tcms-card-header">
          <span className="tcms-card-title">📰 All Tribe Posts ({posts.length})</span>
        </div>
        {posts.length === 0 ? (
          <div className="tcms-empty">
            <div className="tcms-empty-icon">📰</div>
            <div>No posts yet. Be the first — write one above!!</div>
          </div>
        ) : posts.map(p => {
          const isFreshPost   = isNewSince(p.created_at) && !p.is_ceo_post
          const hasFreshReply = !!newReplyPosts[p.id]
          const fresh = isFreshPost || hasFreshReply
          return (
          <div key={p.id} ref={el => { if (fresh && el && !firstNewRef.current) firstNewRef.current = el }} style={{ borderBottom:'1px solid #EFEDE6', ...(fresh ? { background:'#FDF9EE', boxShadow:'inset 3px 0 0 #C9A84C' } : {}) }}>
            <div className="tcms-row" style={{ borderBottom:'none' }}>
              <div style={{ flex:1, minWidth:0 }}>
                <div style={{ display:'flex', alignItems:'center', gap:8, marginBottom:6, flexWrap:'wrap' }}>
                  <strong style={{ fontSize:13, color:'#0D1B3E' }}>{p.author?.full_name || 'Unknown'}</strong>
                  {p.is_ceo_post && <span className="tcms-badge ceo">💜 CEO</span>}
                  {!p.is_ceo_post && <span className="tcms-badge member">MEMBER</span>}
                  {p.is_pinned && <span className="tcms-badge pinned">📌 PINNED</span>}
                  {isFreshPost && <span style={{ fontSize:9, background:'#C9A84C', color:'#0D1B3E', fontWeight:800, padding:'2px 8px', borderRadius:8, letterSpacing:0.5 }}>✨ NEW</span>}
                  <span style={{ fontSize:11, color:'#B8B5AB' }}>{timeAgo(p.created_at)}</span>
                  {likeCounts[p.id] > 0 && <span style={{ fontSize:11, color:'#E91E63', fontWeight:700 }}>❤️ {likeCounts[p.id]}</span>}
                </div>
                <div style={{ fontSize:13, color:'#4A4840', lineHeight:1.6, whiteSpace:'pre-line', wordWrap:'break-word' }}><MentionText text={p.content} names={mentionNames} /></div>
              </div>
              <div style={{ display:'flex', gap:4, flexShrink:0 }}>
                <button className="tcms-btn-icon" onClick={() => togglePin(p)} title={p.is_pinned ? 'Unpin' : 'Pin to top'}>{p.is_pinned ? '📌' : '📍'}</button>
                <button className="tcms-btn-icon" onClick={() => deletePost(p)} style={{ color:'#E24B4A' }} title="Delete">🗑️</button>
              </div>
            </div>

            <div style={{ padding:'0 0 10px 2px' }}>
              <button onClick={() => toggleThread(p.id)} style={{ background:'none', border:'none', color:'#A87CE8', fontSize:12, fontWeight:700, cursor:'pointer', padding:0 }}>
                💬 {openThread[p.id] ? 'Hide replies' : `Reply${commentCounts[p.id] > 0 ? ` · ${commentCounts[p.id]}` : ''}`}
              </button>
              {hasFreshReply && <span style={{ marginLeft:8, fontSize:9, background:'#C9A84C', color:'#0D1B3E', fontWeight:800, padding:'2px 8px', borderRadius:8, letterSpacing:0.5 }}>NEW REPLY</span>}
            </div>

            {openThread[p.id] && (
              <div style={{ background:'#FAF9F6', borderRadius:10, padding:'12px 14px', margin:'0 0 12px' }}>
                {(comments[p.id] || []).length === 0 && <div style={{ fontSize:12, color:'#B8B5AB', marginBottom:8 }}>No replies yet — be the first to respond. 💜</div>}
                {(comments[p.id] || []).map(c => (
                  <div key={c.id} style={{ display:'flex', justifyContent:'space-between', gap:8, padding:'6px 0', borderBottom:'1px solid #EFEDE6' }}>
                    <div style={{ minWidth:0 }}>
                      <div style={{ display:'flex', alignItems:'center', gap:6, flexWrap:'wrap' }}>
                        <strong style={{ fontSize:12, color:'#0D1B3E' }}>{c.is_ceo_comment ? 'Nancy Phillips' : (c.author?.full_name || 'Member')}</strong>
                        {c.is_ceo_comment && <span className="tcms-badge ceo" style={{ fontSize:9 }}>💜 Your Friendly CEO</span>}
                        <span style={{ fontSize:10, color:'#B8B5AB' }}>{timeAgo(c.created_at)}</span>
                        {isNewSince(c.created_at) && !c.is_ceo_comment && c.author_id !== userId && <span style={{ fontSize:8, background:'#C9A84C', color:'#0D1B3E', fontWeight:800, padding:'1px 7px', borderRadius:7, letterSpacing:0.5 }}>NEW</span>}
                      </div>
                      <div style={{ fontSize:12.5, color:'#4A4840', lineHeight:1.5, whiteSpace:'pre-line', wordWrap:'break-word', marginTop:2 }}><MentionText text={c.content} names={mentionNames} /></div>
                    </div>
                    <button onClick={() => deleteComment(p.id, c.id)} title="Delete reply" style={{ background:'none', border:'none', color:'#E24B4A', cursor:'pointer', fontSize:12, flexShrink:0 }}>🗑️</button>
                  </div>
                ))}
                <div style={{ display:'flex', gap:8, marginTop:10 }}>
                  <MentionInput
                    as="input"
                    value={replyDrafts[p.id] || ''}
                    onChange={val => setReplyDrafts(prev => ({ ...prev, [p.id]: val }))}
                    onKeyDown={e => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); sendReply(p.id) } }}
                    placeholder="Reply to the tribe as CEO… (@ to mention)"
                    members={members}
                    extraOptions={[{ full_name: 'everyone', icon: '📣' }]}
                    style={{ width:'100%', border:'1px solid #E0DCCF', borderRadius:8, padding:'8px 12px', fontSize:13, outline:'none', boxSizing:'border-box' }}
                  />
                  <button onClick={() => sendReply(p.id)} disabled={!(replyDrafts[p.id]||'').trim() || replying === p.id}
                    style={{ background:'#A87CE8', color:'#fff', border:'none', borderRadius:8, padding:'8px 16px', fontSize:12, fontWeight:700, cursor:'pointer', opacity:(!(replyDrafts[p.id]||'').trim() || replying===p.id)?0.6:1, whiteSpace:'nowrap' }}>
                    {replying === p.id ? '⏳' : '💜 Reply'}
                  </button>
                </div>
              </div>
            )}
          </div>
          )
        })}
      </div>
    </>
  )
}

// ─── MANAGE COMING SOON TAB ───────────────────────────────────────
function ManageComingSoonTab() {
  const [features, setFeatures] = useState([])
  const [loading,  setLoading]  = useState(true)
  const [editing,  setEditing]  = useState(null)
  const [form,     setForm]     = useState({ title:'', description:'', icon:'⭐', status:'planned', sort_order:0, published:true })
  const [saving,   setSaving]   = useState(false)
  const [voteCounts, setVoteCounts] = useState({})

  useEffect(() => { load() }, [])

  async function load() {
    try {
      const { data: feats } = await supabase.from('tribe_feature_requests').select('*').order('sort_order', { ascending: true })
      setFeatures(feats || [])

      if (feats && feats.length > 0) {
        const ids = feats.map(f => f.id)
        const { data: votes } = await supabase.from('tribe_feature_votes').select('feature_id').in('feature_id', ids)
        const counts = {}
        ids.forEach(id => { counts[id] = 0 })
        ;(votes || []).forEach(v => { counts[v.feature_id] = (counts[v.feature_id] || 0) + 1 })
        setVoteCounts(counts)
      }
    } catch (err) {
      console.warn('[TribeCMS] features load:', err.message)
    } finally {
      setLoading(false)
    }
  }

  function openNew() {
    setForm({ title:'', description:'', icon:'⭐', status:'planned', sort_order: features.length + 1, published:true })
    setEditing('new')
  }

  function openEdit(f) {
    setForm({ title:f.title, description:f.description||'', icon:f.icon||'⭐', status:f.status||'planned', sort_order:f.sort_order||0, published:!!f.published })
    setEditing(f)
  }

  async function save() {
    if (!form.title.trim()) { toast.error('Title is required!!'); return }
    setSaving(true)
    try {
      const payload = {
        title:       form.title.trim(),
        description: form.description.trim() || null,
        icon:        form.icon || '⭐',
        status:      form.status,
        sort_order:  Number(form.sort_order) || 0,
        published:   form.published,
        updated_at:  new Date().toISOString(),
      }
      if (editing === 'new') {
        const { error } = await supabase.from('tribe_feature_requests').insert(payload)
        if (error) throw error
        toast.success('✅ Sneak preview added!!')
      } else {
        const { error } = await supabase.from('tribe_feature_requests').update(payload).eq('id', editing.id)
        if (error) throw error
        toast.success('✅ Sneak preview updated!!')
      }
      setEditing(null)
      load()
    } catch (err) {
      toast.error(err.message)
    } finally {
      setSaving(false)
    }
  }

  async function deleteFeature(f) {
    if (!window.confirm(`Delete "${f.title}"?`)) return
    await supabase.from('tribe_feature_requests').delete().eq('id', f.id)
    toast.success('Deleted')
    load()
  }

  if (loading) return <div className="tcms-empty">Loading sneak previews...</div>

  return (
    <>
      {editing && (
        <div className="tcms-card" style={{ border:'2px solid #A87CE8' }}>
          <div className="tcms-card-header">
            <span className="tcms-card-title">{editing === 'new' ? '➕ Add Sneak Preview' : `✏️ Edit: ${editing.title}`}</span>
            <button className="tcms-btn-icon" onClick={() => setEditing(null)}>✕</button>
          </div>
          <div className="tcms-card-body">
            <div className="tcms-form">
              <div>
                <label className="tcms-label">TITLE *</label>
                <input className="tcms-input" placeholder="e.g. Discussion Channels" value={form.title} onChange={e => setForm(f => ({ ...f, title:e.target.value }))} />
              </div>
              <div>
                <label className="tcms-label">DESCRIPTION</label>
                <textarea className="tcms-textarea" placeholder="What is this feature about??" value={form.description} onChange={e => setForm(f => ({ ...f, description:e.target.value }))} />
              </div>
              <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr 1fr', gap:12 }}>
                <div>
                  <label className="tcms-label">ICON (emoji)</label>
                  <input className="tcms-input" maxLength={4} value={form.icon} onChange={e => setForm(f => ({ ...f, icon:e.target.value }))} />
                </div>
                <div>
                  <label className="tcms-label">STATUS</label>
                  <select className="tcms-select" value={form.status} onChange={e => setForm(f => ({ ...f, status:e.target.value }))}>
                    {CS_STATUSES.map(s => <option key={s} value={s}>{s}</option>)}
                  </select>
                </div>
                <div>
                  <label className="tcms-label">SORT ORDER</label>
                  <input className="tcms-input" type="number" value={form.sort_order} onChange={e => setForm(f => ({ ...f, sort_order:e.target.value }))} />
                </div>
              </div>
              <label className="tcms-check">
                <input type="checkbox" checked={form.published} onChange={e => setForm(f => ({ ...f, published:e.target.checked }))} style={{ width:'auto' }} />
                <span>Published (visible to tribe)</span>
              </label>
              <div style={{ display:'flex', gap:10, justifyContent:'flex-end' }}>
                <button className="tcms-btn-ghost" onClick={() => setEditing(null)}>Cancel</button>
                <button className="tcms-btn-primary" onClick={save} disabled={saving}>{saving ? 'Saving...' : '✅ Save'}</button>
              </div>
            </div>
          </div>
        </div>
      )}

      <div className="tcms-card">
        <div className="tcms-card-header">
          <span className="tcms-card-title">🚪 Coming Soon Lounge ({features.length} items)</span>
          <button className="tcms-btn-primary" onClick={openNew}>➕ Add Sneak Preview</button>
        </div>
        {features.length === 0 ? (
          <div className="tcms-empty">
            <div className="tcms-empty-icon">🚪</div>
            <div>No sneak previews yet!!</div>
          </div>
        ) : features.map(f => (
          <div key={f.id} className="tcms-row">
            <div style={{ fontSize:24, flexShrink:0 }}>{f.icon || '⭐'}</div>
            <div style={{ flex:1, minWidth:0 }}>
              <div style={{ display:'flex', alignItems:'center', gap:8, flexWrap:'wrap', marginBottom:4 }}>
                <strong style={{ fontSize:13, color:'#0D1B3E' }}>{f.title}</strong>
                <span className={`tcms-badge ${f.status}`}>{f.status.toUpperCase()}</span>
                <span style={{ fontSize:11, color:'#A87CE8', fontWeight:600 }}>🗳️ {voteCounts[f.id] || 0} vote{(voteCounts[f.id] || 0) !== 1 ? 's' : ''}</span>
                {!f.published && <span className="tcms-badge archived">HIDDEN</span>}
              </div>
              {f.description && <div style={{ fontSize:12, color:'#7A7870', lineHeight:1.5 }}>{f.description}</div>}
            </div>
            <div style={{ display:'flex', gap:4, flexShrink:0 }}>
              <button className="tcms-btn-icon" onClick={() => openEdit(f)}>✏️</button>
              <button className="tcms-btn-icon" onClick={() => deleteFeature(f)} style={{ color:'#E24B4A' }}>🗑️</button>
            </div>
          </div>
        ))}
      </div>
    </>
  )
}

// ─── PAIN POINTS INBOX TAB ────────────────────────────────────────
function PainPointsInbox() {
  const [points,  setPoints]  = useState([])
  const [loading, setLoading] = useState(true)
  const [filter,  setFilter]  = useState('new')
  const [savingNote, setSavingNote] = useState(null)
  const [noteEdits, setNoteEdits] = useState({}) // id -> string

  useEffect(() => { load() }, [])

  async function load() {
    try {
      const { data } = await supabase
        .from('tribe_pain_points')
        .select('*')
        .order('created_at', { ascending: false })
        .limit(200)
      setPoints(data || [])
      const notes = {}
      ;(data || []).forEach(p => { notes[p.id] = p.admin_notes || '' })
      setNoteEdits(notes)
    } catch (err) {
      console.warn('[TribeCMS] pain points load:', err.message)
    } finally {
      setLoading(false)
    }
  }

  async function updateStatus(p, newStatus) {
    await supabase.from('tribe_pain_points').update({ status: newStatus, updated_at: new Date().toISOString() }).eq('id', p.id)
    toast.success(`Marked as ${newStatus}`)
    load()
  }

  async function saveNote(p) {
    setSavingNote(p.id)
    try {
      await supabase.from('tribe_pain_points').update({ admin_notes: noteEdits[p.id] || null, updated_at: new Date().toISOString() }).eq('id', p.id)
      toast.success('Note saved 🔒')
    } catch (err) {
      toast.error(err.message)
    } finally {
      setSavingNote(null)
    }
  }

  const filtered = points.filter(p => filter === 'all' ? true : p.status === filter)
  const counts = PP_STATUSES.reduce((acc, s) => ({ ...acc, [s]: points.filter(p => p.status === s).length }), {})

  if (loading) return <div className="tcms-empty">Loading pain points...</div>

  return (
    <>
      <div className="tcms-stat-grid">
        {PP_STATUSES.map(s => (
          <div key={s} className="tcms-stat-card" style={{ cursor:'pointer', borderColor: filter === s ? '#A87CE8' : '#E8E6DF' }} onClick={() => setFilter(s)}>
            <div className="tcms-stat-label">{s.toUpperCase()}</div>
            <div className="tcms-stat-value" style={{ color: filter === s ? '#A87CE8' : '#0D1B3E' }}>{counts[s] || 0}</div>
            <div className="tcms-stat-sub">click to filter</div>
          </div>
        ))}
        <div className="tcms-stat-card" style={{ cursor:'pointer', borderColor: filter === 'all' ? '#A87CE8' : '#E8E6DF' }} onClick={() => setFilter('all')}>
          <div className="tcms-stat-label">ALL</div>
          <div className="tcms-stat-value" style={{ color: filter === 'all' ? '#A87CE8' : '#0D1B3E' }}>{points.length}</div>
          <div className="tcms-stat-sub">total submissions</div>
        </div>
      </div>

      {filtered.length === 0 ? (
        <div className="tcms-card">
          <div className="tcms-empty">
            <div className="tcms-empty-icon">💚</div>
            <div>{filter === 'new' ? 'No new pain points right now — your tribe is happy!!' : `No items with status "${filter}".`}</div>
          </div>
        </div>
      ) : filtered.map(p => (
        <div key={p.id} className="tcms-pp-card">
          <div className="tcms-pp-head">
            <div>
              <div style={{ display:'flex', alignItems:'center', gap:8, flexWrap:'wrap' }}>
                <strong style={{ fontSize:13, color:'#0D1B3E' }}>
                  {p.is_anonymous ? '🤫 Anonymous' : (p.author_name || 'Tribe Member')}
                </strong>
                <span className="tcms-badge member">{PAIN_CATEGORIES[p.category] || p.category}</span>
                <span className={`tcms-badge ${p.status}`}>{p.status.toUpperCase()}</span>
              </div>
              <div className="tcms-pp-meta" style={{ marginTop:4 }}>{timeAgo(p.created_at)}</div>
            </div>
            <select className="tcms-select" style={{ width:160 }} value={p.status} onChange={e => updateStatus(p, e.target.value)}>
              {PP_STATUSES.map(s => <option key={s} value={s}>{s}</option>)}
            </select>
          </div>

          <div className="tcms-pp-text"><strong>😣 Pain:</strong> {p.pain_point}</div>
          {p.ideal_fix && <div className="tcms-pp-fix"><strong>💡 Ideal fix:</strong> {p.ideal_fix}</div>}

          <div style={{ marginTop:12 }}>
            <label className="tcms-label">🔒 PRIVATE ADMIN NOTES</label>
            <textarea
              className="tcms-textarea"
              placeholder="Notes only you see..."
              value={noteEdits[p.id] || ''}
              onChange={e => setNoteEdits(prev => ({ ...prev, [p.id]: e.target.value }))}
              style={{ minHeight: 60 }}
            />
            <div style={{ display:'flex', justifyContent:'flex-end', marginTop:8 }}>
              <button className="tcms-btn-primary" onClick={() => saveNote(p)} disabled={savingNote === p.id}>
                {savingNote === p.id ? 'Saving...' : '💾 Save Note'}
              </button>
            </div>
          </div>
        </div>
      ))}
    </>
  )
}

// ─── ANALYTICS TAB ────────────────────────────────────────────────
function AnalyticsTab() {
  const [stats, setStats] = useState({ posts:0, comments:0, likes:0, members:0, painNew:0, painTotal:0, votes:0 })
  const [loading, setLoading] = useState(true)
  const [topVoted, setTopVoted] = useState([])

  useEffect(() => { load() }, [])

  async function load() {
    try {
      const safeCount = async (table, filters) => {
        try {
          let q = supabase.from(table).select('*', { count:'exact', head:true })
          if (filters) Object.entries(filters).forEach(([k,v]) => { q = q.eq(k, v) })
          const { count } = await q
          return count || 0
        } catch { return 0 }
      }

      const [posts, comments, likes, members, painNew, painTotal, votes] = await Promise.all([
        safeCount('tribe_posts'),
        safeCount('tribe_post_comments'),
        safeCount('tribe_post_likes'),
        safeCount('profiles', { role:'notary', is_approved:true }),
        safeCount('tribe_pain_points', { status:'new' }),
        safeCount('tribe_pain_points'),
        safeCount('tribe_feature_votes'),
      ])
      setStats({ posts, comments, likes, members, painNew, painTotal, votes })

      // Top voted features
      const { data: feats } = await supabase.from('tribe_feature_requests').select('*').eq('published', true)
      if (feats && feats.length > 0) {
        const ids = feats.map(f => f.id)
        const { data: allVotes } = await supabase.from('tribe_feature_votes').select('feature_id').in('feature_id', ids)
        const counts = {}
        ids.forEach(id => { counts[id] = 0 })
        ;(allVotes || []).forEach(v => { counts[v.feature_id] = (counts[v.feature_id] || 0) + 1 })
        const sorted = feats.map(f => ({ ...f, votes: counts[f.id] || 0 })).sort((a, b) => b.votes - a.votes).slice(0, 5)
        setTopVoted(sorted)
      }
    } catch (err) {
      console.warn('[TribeCMS] analytics load:', err.message)
    } finally {
      setLoading(false)
    }
  }

  if (loading) return <div className="tcms-empty">Loading tribe analytics...</div>

  return (
    <>
      <div className="tcms-stat-grid">
        <div className="tcms-stat-card"><div className="tcms-stat-label">TRIBE MEMBERS</div><div className="tcms-stat-value">{stats.members}</div><div className="tcms-stat-sub">approved notaries</div></div>
        <div className="tcms-stat-card"><div className="tcms-stat-label">POSTS</div><div className="tcms-stat-value">{stats.posts}</div><div className="tcms-stat-sub">in the feed</div></div>
        <div className="tcms-stat-card"><div className="tcms-stat-label">COMMENTS</div><div className="tcms-stat-value">{stats.comments}</div><div className="tcms-stat-sub">conversations</div></div>
        <div className="tcms-stat-card"><div className="tcms-stat-label">LIKES</div><div className="tcms-stat-value">{stats.likes}</div><div className="tcms-stat-sub">love given</div></div>
        <div className="tcms-stat-card" style={{ borderColor: stats.painNew > 0 ? '#E24B4A' : '#E8E6DF' }}>
          <div className="tcms-stat-label">PAIN POINTS</div>
          <div className="tcms-stat-value" style={{ color: stats.painNew > 0 ? '#E24B4A' : '#0D1B3E' }}>{stats.painNew}</div>
          <div className="tcms-stat-sub">new ({stats.painTotal} total)</div>
        </div>
        <div className="tcms-stat-card"><div className="tcms-stat-label">FEATURE VOTES</div><div className="tcms-stat-value">{stats.votes}</div><div className="tcms-stat-sub">voices heard</div></div>
      </div>

      <div className="tcms-card">
        <div className="tcms-card-header"><span className="tcms-card-title">🏆 Top Voted Features</span></div>
        {topVoted.length === 0 ? (
          <div className="tcms-empty">
            <div className="tcms-empty-icon">🗳️</div>
            <div>No votes yet — the tribe hasn't spoken!!</div>
          </div>
        ) : topVoted.map((f, idx) => (
          <div key={f.id} className="tcms-row">
            <div style={{ fontSize:18, color:'#C9A84C', fontWeight:700, minWidth:30 }}>#{idx + 1}</div>
            <div style={{ fontSize:24, flexShrink:0 }}>{f.icon}</div>
            <div style={{ flex:1 }}>
              <div style={{ fontSize:13, fontWeight:600, color:'#0D1B3E' }}>{f.title}</div>
              <div style={{ fontSize:11, color:'#7A7870' }}>{f.description}</div>
            </div>
            <div style={{ fontSize:14, fontWeight:700, color:'#A87CE8' }}>🗳️ {f.votes}</div>
          </div>
        ))}
      </div>
    </>
  )
}

// ─── MAIN ─────────────────────────────────────────────────────────
export default function TribeCMS() {
  const { user } = useAuth() || {}
  const [tab, setTab] = useState('posts')
  const [newPainCount, setNewPainCount] = useState(0)

  useEffect(() => {
    async function check() {
      try {
        const { count } = await supabase.from('tribe_pain_points').select('*', { count:'exact', head:true }).eq('status', 'new')
        setNewPainCount(count || 0)
      } catch {}
    }
    check()
  }, [tab])

  return (
    <>
      <style>{TCMS_STYLES}</style>
      <div className="tcms-hero">
        <div className="tcms-hero-title">💜 The Lounge Command Center</div>
        <div className="tcms-hero-sub">Manage the LCA Tribe — post as CEO, curate sneak previews, harvest pain points into gold, and track the pulse of your community!!</div>
      </div>

      <div className="tcms-tabs">
        <button className={`tcms-tab${tab==='posts'?' active':''}`} onClick={() => setTab('posts')}>📰 Manage Posts</button>
        <button className={`tcms-tab${tab==='coming-soon'?' active':''}`} onClick={() => setTab('coming-soon')}>🚪 Coming Soon</button>
        <button className={`tcms-tab${tab==='pain-points'?' active':''}`} onClick={() => setTab('pain-points')}>
          🆘 Pain Points
          {newPainCount > 0 && <span className="tcms-tab-badge">{newPainCount}</span>}
        </button>
        <button className={`tcms-tab${tab==='analytics'?' active':''}`} onClick={() => setTab('analytics')}>📊 Analytics</button>
      </div>

      {tab === 'posts'        && <ManagePostsTab userId={user?.id} />}
      {tab === 'coming-soon'  && <ManageComingSoonTab />}
      {tab === 'pain-points'  && <PainPointsInbox />}
      {tab === 'analytics'    && <AnalyticsTab />}
    </>
  )
}
